<template>
  <div class="tw-p-2 tw-border tw-border-primary tw-border-solid tw-rounded-xl">
    <ValidationProvider
      v-slot="{ errors }"
      :name="name"
      :rules="file.id ? '' : rules"
    >
      <div class="input_wrapper">
        <div class="tw-flex tw-items-center tw-justify-between tw-mb-2">
          <label :for="name">{{ label }}</label>

          <button
            v-if="file.id"
            type="button"
            @click="confirmDelete"
            class="tw-border tw-border-solid tw-border-red-500 tw-rounded-lg tw-text-red-500 tw-px-2"
          >
            <i class="fas fa-trash"></i>
          </button>
        </div>
        <div
          class="tw-flex tw-items-center tw-justify-between tw-mb-2 tw-gap-2"
        >
          <v-file-input
            :disabled="btnLoading"
            :loading="btnLoading"
            @change="uploadImage($event)"
            :name="name"
            label=""
            v-model="file.mainMedia"
            :id="name"
            ref="uploadInput"
          ></v-file-input>
          <button
            v-if="file.preview"
            type="button"
            @click="openPreview = true"
            class="tw-border tw-border-solid tw-rounded-lg tw-text-text tw-px-2"
          >
            <i class="fas fa-eye"></i>
          </button>

          <media-modal
            v-if="openPreview"
            :preview="file.preview"
            type="image"
            @close="openPreview = false"
          />
        </div>
      </div>
      <span v-if="errors[0]" class="error--text d-inline-block">
        {{ errors[0] }}
      </span>
    </ValidationProvider>

    <div
      class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-2 tw-mt-3"
      v-if="!data.noAlt"
    >
      <ValidationProvider
        v-slot="{ errors }"
        :name="$t('labels.alt') + $t('inArabic')"
        :rules="rules"
      >
        <div class="input_wrapper">
          <label for="alt_ar">{{ $t("labels.alt") + $t("inArabic") }}</label>

          <app-input
            @input="updateValue"
            v-model="file.alt_ar"
            id="alt_ar"
            type="text"
            :placeholder="$t('labels.alt') + $t('inArabic')"
            :name="$t('labels.alt') + $t('inArabic')"
          ></app-input>
        </div>
        <span v-if="errors[0]" class="error--text d-inline-block">
          {{ errors[0] }}
        </span>
      </ValidationProvider>
      <ValidationProvider
        v-slot="{ errors }"
        :name="$t('labels.alt') + $t('inEnglish')"
        :rules="rules"
      >
        <div class="input_wrapper">
          <label for="alt_en">{{ $t("labels.alt") + $t("inEnglish") }}</label>

          <app-input
            @input="updateValue"
            id="alt_en"
            v-model="file.alt_en"
            type="text"
            :placeholder="$t('labels.alt') + $t('inEnglish')"
            :name="$t('labels.alt') + $t('inEnglish')"
          ></app-input>
        </div>
        <span v-if="errors[0]" class="error--text d-inline-block">
          {{ errors[0] }}
        </span>
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
    },
    label: {
      required: false,
    },
    rules: {
      required: true,
    },
    data: {
      required: false,
    },
    type: {
      required: false,
      default: "text",
    },
    value: {
      required: true,
    },
    placeholder: {
      required: false,
    },
    modalName: {
      required: false,
    },
  },
  data() {
    return {
      file: {
        mainMedia: null,
        preview: null,
        image: null,
        alt_ar: null,
        alt_en: null,
        id: "",
      },
      openPreview: false,
      btnLoading: false,
    };
  },

  methods: {
    uploadImage(event) {
      if (event) {
        if (this.modalName) {
          this.btnLoading = true;
          const data = new FormData();
          data.append("file", event);
          data.append("attachment_type", "image");
          data.append("model", this.modalName);

          this.axios({
            method: "POST",
            url: `${process.env.VUE_APP_BASE_URL_GENERAL}/api/general/attachments`,
            data: data,
          })
            .then((res) => {
              this.file.image = res.data.data;

              this.file.preview = URL.createObjectURL(event);
              this.$emit("input", this.file);
              this.btnLoading = false;
            })
            .catch((err) => {
              this.file.mainMedia = null;

              this.$iziToast.error({
                title: this.$t("validation.error"),
                message: err.response.data.message,
              });

              this.btnLoading = false;
            });
        } else {
          this.file.image = event;

          this.file.preview = URL.createObjectURL(event);
          this.$emit("input", this.file);
        }
      }
    },

    deleteImage() {
      this.axios({
        method: "DELETE",
        url: `${process.env.VUE_APP_BASE_URL_GENERAL}/api/general/attachments/${this.file.id}`,
      })
        .then(() => {
          this.file = {
            mainMedia: null,
            preview: null,
            image: null,
            alt_ar: null,
            alt_en: null,
            id: "",
          };
          this.$emit("imageDeleted");
          this.$swal({
            title: "تم الحذف بنجاح",
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "نعم",
          });
        })
        .catch((err) => {
          this.$swal({
            title: err.response.data.message,
            icon: "error",
            confirmButtonColor: "#d33",
            confirmButtonText: "اغلاق",
          });
        });
    },
    confirmDelete() {
      this.$swal({
        title: "هل أنت متأكد؟",
        text: "سيتم حذف الصوره بالنص البديل لن يكون بإمكانك الرجوع في العملية!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "لا",
        confirmButtonText: "احذف",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteImage();
        }
      });
      // End:: Sweet Alert  Modal
    },
    updateValue() {
      this.$emit("input", this.file);
    },
  },
  mounted() {
    if (this.data.modelValue) {
      this.file.preview = this.data.modelValue.media;
      if (!this.data.noAlt) {
        this.file.alt_ar = this.data.modelValue.ar.alt;
        this.file.alt_en = this.data.modelValue.en.alt;
      }
      this.file.id = this.data.modelValue.id;
    }
  },
};
</script>

<style></style>
